export default __webpack_public_path__ + "static/media/865.5766505b.png";